import { useMutation } from "@tanstack/react-query";
import { asyncSleep } from "../../../utils";
import { logError } from "../../../utils/error";

export const useSilentlyDeleteFile = () => {
	const mutation = useMutation({
		mutationKey: ["silentlyDeleteFile"],
		mutationFn: async (_args: { fileId: string }) => {
			await asyncSleep(1000);
		},
		onError: (error: Error, args) => {
			//TODO: ERROR - triggerErrorModal?
			logError(error);
			console.error(`Error silently deleting file with id ${args.fileId}: `, error);
		},
	});

	return { silentlyDeleteFile: mutation.mutate };
};
